import { createContext, useContext } from "react";

export const VaultRequirementIdContext = createContext<string | undefined>(
  undefined,
);

export function useScopedVaultRequirementId() {
  return useContext(VaultRequirementIdContext);
}
